export var TAG_TYPES = {
    META: 'meta',
    SCRIPT: 'script',
    LINK: 'link',
    TITLE: 'title',
};
